import { setAppStore } from '@/store';
import { HOME_TOOLS } from '@/consts/homeTools';
import { HOME_FEED_SLUG } from '@/store/homeTabs/types';
import { Screen } from '@/types';

import type { Deeplink } from '../types';
import { DeeplinkKind } from '../types';

type ToolDeeplink = Extract<Deeplink, { kind: DeeplinkKind.Tool }>;

const isKnownTool = (slug: string): boolean =>
  slug === HOME_FEED_SLUG || HOME_TOOLS.some((tool) => tool.slug === slug);

/**
 * Tool deeplink (`tool=dance`): open the home and activate the named tool tab
 * (`store.activeHomeTab`, read by `HomeToolTabs` / `CategoryRowsHome`). The
 * slug must match a registered `HOME_TOOLS` entry (or the default feed);
 * unknown slugs are ignored so a bad link just lands on the home feed.
 *
 * When the deeplink targets an actual tool, the whole tab row is hidden
 * (`hideHomeTabs`) for a focused, standalone tool — there's nothing to switch
 * to, so the tabs add no value.
 */
const toolHandler = ({ tool }: ToolDeeplink): void => {
  if (!isKnownTool(tool)) return;

  setAppStore({
    screen: Screen.Library,
    activeHomeTab: tool,
    hideHomeTabs: tool !== HOME_FEED_SLUG,
  });
};

export default toolHandler;
